import React from "react";

import infoIcon from "../../Images/info-icon.svg";

export default function CounterModal({
  resetType,
  onCancel,
  onConfirm,
}) {
  // -------------------------
  // Derived values
  // -------------------------
  const isDelete = resetType === "delete";

  const confirmLabel = isDelete ? "Delete" : "Reset";

  const message = isDelete
    ? "Do you want to delete this Counter?"
    : `Do you want to reset the ${
        resetType === "timer" ? "Timer" : "Count"
      }?`;

  // -------------------------
  // Handlers
  // -------------------------
  const handleCancel = () => {
    onCancel?.();
  };

  const handleConfirm = () => {
    onConfirm?.();
  };

  // -------------------------
  // Render
  // -------------------------
  return (
    <>
      {/* Overlay */}
      <div
        className="overlay"
        onClick={handleCancel}
      />

      {/* Modal */}
      <div
        className="modalWrapper show"
        role="dialog"
        aria-modal="true"
        aria-label="Confirmation dialog"
      >
        {/* Header */}
        <div className="confirmText">
          <span className="confirmIcon">
            <img src={infoIcon} alt="" />
          </span>
          Confirm
        </div>

        {/* Message */}
        <p>{message}</p>

        {/* Actions */}
        <div className="btnWrapper">
          <button
            type="button"
            onClick={handleCancel}
          >
            Cancel
          </button>

          <button
            type="button"
            className="confirm"
            onClick={handleConfirm}
            aria-label={confirmLabel}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </>
  );
}